import React from 'react'
import StarDefaultIcon from '@/components/icons/StarDefaultIcon'
import RoundedButton from './RoundedButton'
import { FloatingInspectorButtonArrow, PopoverContentType } from '../../FloatingInspectorButton/FloatingInspectorButton'

type SuggestedButtonProps = {
  text: string
  icon?: React.ReactNode
  onClick: () => void
  tooltipText?: string
  popoverContent?: PopoverContentType
  showArrow?: FloatingInspectorButtonArrow
}

function SuggestedButton({ text, icon, onClick, tooltipText, popoverContent, showArrow }: SuggestedButtonProps) {
  return (
    <RoundedButton
        text={text}
        state='default'
        icon={icon || <StarDefaultIcon />}
        onClick={onClick}
        tooltipText={tooltipText}
        popoverContent={popoverContent}
        showArrow={showArrow}
    ></RoundedButton>
  )
}

export default SuggestedButton